// Note these environments have to match up with those passed into scripts in package.json
export const LocalHost = 'local'
export const Development = 'dev'
export const Test = 'qa'
export const Staging = 'staging'
export const Production = 'production'
